import { useCallback, useContext } from 'react'
import { ConfigContext } from '#src/contexts/config/ConfigContext.tsx'

/**
 * Origin for copied Portal links: the configured Portal origin when the host
 * is not Portal itself (ConfigContext.portalOrigin), else the current origin.
 *
 * @returns A getter to call in event handlers (no window under SSR).
 */
export function useLinkOrigin(): () => string {
  const portalOrigin = useContext(ConfigContext)?.portalOrigin
  return useCallback(
    () => portalOrigin ?? window.location.origin,
    [portalOrigin]
  )
}
